import { render, staticRenderFns } from "./SendLeadList.vue?vue&type=template&id=577f9ed5"
import script from "./SendLeadList.vue?vue&type=script&lang=js"
export * from "./SendLeadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports